import CheckoutPage from "../Components/CheckOut/checkOut";
import PrivateLayout from "../layout/PrivateLayout";




const privateRoutes = [
	// {
	// 	path: "/dashboard",
	// 	exact: true,
	// 	layout: PrivateLayout,
	// 	element: <div>Dashboard Page</div>
	// },
	{
		path: "/checkout",
		element: (
			<PrivateLayout>
				<CheckoutPage />
			</PrivateLayout>
		)
	}
];
export default privateRoutes;
